<template>
  <div v-if="asset != null">
    <template v-if="project">
      <div class="text-center mt-4">
        <b-img
          v-if="project.urlLogoProyecto && !['cuadrado'].includes(template)"
          :src="setPhoto(project.urlLogoProyecto, project.urlLogoProyecto)"
          class="w-50 mx-auto d-lg-none"
          alt=""
        ></b-img>
      </div>
      <b-media class="mr-2 mb-4" vertical-align="center">
        <template v-if="!['cuadrado'].includes(template)" #aside>
          <b-img
            v-if="project.urlLogoProyecto"
            :src="setPhoto(project.urlLogoProyecto, project.urlLogoProyecto)"
            class="logo d-none d-lg-block"
            alt=""
          ></b-img>
        </template>
        <b-media-body>
          <h1 class="mt-4 title-asset">
            {{ asset.asset_type }} {{ asset.number }} |
            <small class="text-muted"> {{ asset.project_name }}</small>
          </h1>
          <h5 class="address-asset">{{ address }}<br />{{ addressCountry }}</h5>
        </b-media-body>
      </b-media>
    </template>
    <options
      :asset_id="asset.asset_id"
      :project_id="asset.project_id"
      :tab_index="tab_index"
      :features="features"
      :photos="photos"
      :images="images"
    />
  </div>
</template>
<script>
import options from "./Options";
export default {
  name: "apartments",
  components: { options },
  props: {
    asset: { default: null },
    tab_index: { default: null },
    photos: { default: [] },
    images: { default: [] },
    features: { default: [] },
  },
  data() {
    return {
      selectedApartment: null,
      apartments: [],
      //domain: process.env.VUE_APP_CUSTOMER_DOMAIN
    };
  },
  mounted() {},
  methods: {
    setPhoto(photo, photoComplete) {
      return "https://s3.amazonaws.com/gestion.mobysuite/" + photoComplete;
    },
  },
  computed: {
    domain() {
      return this.$store.getters.getCustomerDomain;
    },
    version() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.gc_version
        : 1;
    },
    project() {
      return this.asset
        ? this.$store.getters.getProjectByMoby(this.asset.project_id)
        : null;
    },
    address() {
      if (this.version == 1) {
        return this.project
          ? `${this.project.direccion.direccion}, ${this.project.direccion.comuna}`
          : "";
      } else {
        return this.project
          ? `${this.project.direccion.calle}, ${this.project.direccion.municipio}`
          : "";
      }
    },
    addressCountry() {
      return this.project
        ? `${this.project.direccion.ciudad} ${this.project.direccion.pais}`
        : "";
    },
    country() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.country
        : 1;
    },
    template() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.template
        : "default";
    },
  },
};
</script>
<style>
.list-Apartment {
  height: 16em;
}
</style>
